"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var React = _interopRequireWildcard(require("react"));

var Styled = _interopRequireWildcard(require("./Telephone.style"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
} // See https://stackoverflow.com/questions/8358084/regular-expression-to-reformat-a-us-phone-number-in-javascript


function formatPhoneNumberUS(phoneNumber) {
  var match = phoneNumber.trim().match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return ['(', match[2], ') ', match[3], '-', match[4]].join('');
  } // if we don't have a phone number match, just give back whatever was provided


  return phoneNumber;
}

var Telephone = function Telephone(_a) {
  var phoneNumber = _a.phoneNumber,
      className = _a.className,
      style = _a.style,
      useFormatter = _a.useFormatter,
      showIcon = _a.showIcon,
      _b = _a.formatFunction,
      formatFunction = _b === void 0 ? formatPhoneNumberUS : _b,
      children = _a.children;
  var content = children || (useFormatter ? formatFunction(phoneNumber) : phoneNumber);
  var href = phoneNumber.replace(/\D/g, '').replace(/^/, 'tel:');
  var props = {
    phoneNumber: phoneNumber,
    className: className,
    style: style,
    children: content,
    href: href
  };
  return React.createElement(Styled.PhoneRow, {
    "data-testid": "phone"
  }, showIcon && React.createElement(Styled.PhoneIcon, {
    height: 16,
    width: 16
  }), React.createElement(Styled.PhoneNumberText, {
    as: "span"
  }, React.createElement(Styled.TelephoneControl, (0, _tslib.__assign)({}, props))));
};

Telephone.displayName = 'Telephone';
var _default = Telephone;
exports.default = _default;